<template>
  <div id="Report" style="height: 100%; margin: 0px; padding: 0px">
    <template v-if="isAdmin()">
      <a-layout style="height: 100%; margin: 0px; padding: 0px">
        <div style="overflow: auto">
          <a-layout-sider style="">
            <a-menu
              mode="inline"
              @click="handleClick"
              :openKeys="openKeys"
              @openChange="onOpenChange"
              style="width: 200px; height: 100%"
            >
              <template v-for="leadername in GroupArr">
                <a-sub-menu :key="leadername">
                  <span slot="title">
                    <a-icon type="setting" /><span>{{ leadername }}</span>
                  </span>
                  <template v-for="person in PersonInfo[leadername]">
                    <a-menu-item style="height: 28px" :key="person.personID">{{
                      person.personName
                    }}</a-menu-item>
                  </template>
                </a-sub-menu>
              </template>
            </a-menu>
          </a-layout-sider>
        </div>

        <a-layout-content>
          <div style="height: 100%">
            <ReportCallList :select-person-id="this.selectPersonID" />
          </div>
        </a-layout-content>
      </a-layout>
    </template>
    <template v-else>
      <div style="height: 100%">
        <ReportCallList :select-person-id="this.selectPersonID" />
      </div>
    </template>
  </div>
</template>

<script>
import ReportCallList from '@/views/components/ReportCallList.vue'
import { GetPersonsList } from '@/api/QkidsApi.js'

const GroupArr = []
const PersonInfo = [[]]

export default {
  name: 'Report',
  data () {
    return {
      selectPersonID: localStorage.personID + '',
      rootSubmenuKeys: [''],
      openKeys: [''],
      waitCount: 0,
      GroupArr,
      PersonInfo
    }
  },
  components: {
    ReportCallList
  },
  methods: {
    isAdmin () {
      if (localStorage.isAdmin === '1') {
        return true
      } else {
        return false
      }
    },
    handleClick (e) {
      console.log('click', e, e.key)
      this.selectPersonID = e.key
    },
    onOpenChange (openKeys) {
      const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1)
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : []
      }
    }
  },
  watch: {
    openKeys (val) {
      console.log('openKeys', val)
    }
  },
  created: function () {
    GetPersonsList()
      .then(req => {
        this.PersonInfo = req.data.group
        this.GroupArr = req.data.leaderArr
        this.GroupArr.forEach(itemkey => {
          this.rootSubmenuKeys.push(itemkey)
        })
        console.log(req)
      })
      .catch(err => {
        console.log(err)
      })
    console.log('init Report')
  }

}
</script>
